const MuiFormLabel = {
  root: {
    '&$focused': {
      color: '#342182',
    },
  },
}

export default MuiFormLabel
